import KiosksTable from "./kiosks-table";

export default KiosksTable;
